import './CSUB.scss';
import {PageManager} from '@mvps-genesis/bootstrap';

export default class CSUB extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

}
